import React from "react";

// Shared by the match rows of the pool lists (MatchSummary, MatchSummaryWide and
// SimpleMatchSummary).

// Soccer 8 HF (discontinued) pairs its matches: each odd-numbered match is the
// half-time result and the even-numbered one after it the full-time result.
export const isSoccer8 = (pool_title) => pool_title.startsWith("S8 ");
export const isHalfTime = (item) => parseInt(item.mnum) % 2;

// The half-time or full-time label for a Soccer 8 HF match, or null for any other
// Pool Type. It is returned in an array, as the rows have always rendered it.
export const halfOrFullTime = (pool_title, item, halfTime, fullTime) => {
  if (!isSoccer8(pool_title)) return null;
  return isHalfTime(item) ? [halfTime] : [fullTime];
};

// Form indicators are left out for Megastrike (discontinued).
export const showsForm = (pool_title) => !pool_title.startsWith("Megastrike");

// "2026-10-07 15:00" becomes "7/10 15:00 ". A time on its own just gets the space.
const shortKickoff = (kickoff_string) => {
  if (kickoff_string && kickoff_string.includes(" ")) {
    const regexDate = /\d{4}-0?(\d{1,2})-0?(\d{1,2}) (\d{2}:\d{2})/;
    const match = kickoff_string.match(regexDate);
    return `${match[2]}/${match[1]} ${match[3]} `;
  } else {
    return `${kickoff_string} `;
  }
};

const kickoffContent = (item, pool_title, formMarks) => {
  if (item.ko === "FIELD") return item.ko;
  return (
    <a style={{ color: "#001489" }} href={"/h2h/" + item.id}>
      {showsForm(pool_title) ? formMarks([item.a1, item.a2, item.a3]) : null}
      {shortKickoff(item.ko)}
      {showsForm(pool_title) ? formMarks([item.b1, item.b2, item.b3]) : null}
    </a>
  );
};

const kickoffStyle = { textAlign: "center", whiteSpace: "nowrap" };

// On Soccer 8 HF the half-time row's kickoff cell spans the full-time row too.
const kickoffCell = (item, pool_title, formMarks) => {
  if (!isSoccer8(pool_title)) {
    return <td style={kickoffStyle}>{kickoffContent(item, pool_title, formMarks)}</td>;
  }
  if (!isHalfTime(item)) return null;
  return (
    <td style={kickoffStyle} rowSpan="2">
      {kickoffContent(item, pool_title, formMarks)}
    </td>
  );
};

// The narrow match row: number, teams, and a kickoff cell linking to the
// head-to-head with each team's last three results either side. formMarks turns
// those three results into elements.
export const CompactMatchRow = ({ item, pool_title, formMarks }) => {
  return (
    <tr>
      <td className="bold">
        {"M" + item.mnum}
        {halfOrFullTime(pool_title, item, "H", "F")}
      </td>
      <td>
        {item.teamA}
        {halfOrFullTime(pool_title, item, " (HT)", " (FT)")}
      </td>
      {kickoffCell(item, pool_title, formMarks)}

      <td className="righttext">
        {item.teamB}
        {halfOrFullTime(pool_title, item, " (HT)", " (FT)")}
      </td>
    </tr>
  );
};
